import { ServerBaseUrlKey, getURL } from './servers';

export default {
    getURL() {
        return getURL(ServerBaseUrlKey.API);
    }
};
